import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useProfileState from '@/state/profile/profileState';
import { getReferenceDownload } from '@/services/Profile/Api';
import ViewableItem from '@/components/molecules/ViewableItem.vue';
import usePopupState from '@/state/usePopupState';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileReferencesView',
  setup(__props) {

const { profile } = useProfileState();

const { setPdf, showPopup, hidePopup } = usePopupState();

const references = computed(() => {
  let refs = profile.value?.references?.referencesList ?? [];
  refs = refs.sort((a, b) => b.year - a.year);
  return refs;
});

const view = async (referenceId:string) => {
  showPopup();

  try {
    const { attachment, filename } = await getReferenceDownload(referenceId);

    setPdf(attachment, filename);
  } catch (error) {
    hidePopup();
  }
};


return { __sfc: true,profile, setPdf, showPopup, hidePopup, references, view, ViewableItem }
}

})